const isDecimal = (num) => {
  return num % 1 !== 0
}

export default isDecimal



// WEBPACK FOOTER //
// ./src/Utils/isDecimal.js